/** @format */

import { type ChangeEvent } from 'react';

type RadioProps = {
  id?: string;
  name?: string;
  value?: string;
  checked?: boolean;
  label?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  className?: string;
};

export const Radio = ({
  id,
  name,
  value,
  checked = false,
  label = '',
  onChange = () => {},
  className = ''
}: RadioProps) => {
  return (
    <label className={`custom-radio ${className}`.trim()} htmlFor={id}>
      <input id={id} type="radio" name={name} value={value} checked={checked} onChange={event => onChange(event)} />
      <span className="custom-radio__indicator" aria-hidden="true" />
      <span className="custom-radio__label">{label}</span>
    </label>
  );
};
